// frontend/src/api/admin.api.js
import apiClient from './client.js';

export const getAdmins = async () => {
  const response = await apiClient.get('/admins');
  return response.data.data;
};

export const createAdmin = async (data) => {
  const response = await apiClient.post('/admins', data);
  return response.data.data;
};

export const updateAdmin = async (id, data) => {
  const response = await apiClient.put(`/admins/${id}`, data);
  return response.data.data;
};

export const resetAdminPassword = async (id, password) => {
  const response = await apiClient.post(`/admins/${id}/reset-password`, { password });
  return response.data.data;
};
